<template>
  <div class="buttons">
    <button
      type="button"
      class="button"
      :class="buttonClass"
      :disabled="disabled"
      @click="$emit('save')"
      @keyup.enter="$emit('save')">

      <span>{{ saveCaption }}</span>

      <span class="icon" v-show="status != 0">
        <i :class="iconClass"></i>
      </span>
    </button>

    <button
      v-show="!noCancel"
      type="button"
      class="button"
      @click="$emit('cancel')"
      @keyup.enter="$emit('cancel')">
      {{ cancelCaption }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    saveCaption: {
      type: String,
      default: 'Opslaan'
    },
    saveClass: {
      type: String,
      default: 'is-info'
    },
    cancelCaption: {
      type: String,
      default: 'Annuleren'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    noCancel: {
      type: Boolean,
      default: false
    },
    status: {
      type: Number,
      default: 0
    }
  },
  computed: {
    iconClass () {
      const classes = []

      switch (this.status) {
        case 1:
          classes.push('fas', 'fa-circle-notch', 'fa-spin')
          break
        case 2:
          classes.push('fas', 'fa-check')
          break
        case 3:
          classes.push('fas', 'fa-times')
          break
      }

      return (classes.length > 0) ? classes.join(' ') : null
    },
    buttonClass () {
      switch (this.status) {
        case 1:
          return 'is-info'
        case 2:
          return 'is-success'
        case 3:
          return 'is-danger'
        default:
          return this.saveClass
      }
    }
  }
}
</script>
